export interface Movie {
  adult: boolean
  backdropPath: string
  genreIds: number[]
  id: number
  originalLanguage: string
  originalTitle: string
  overview: string
  popularity: number
  posterPath: string
  releaseDate: string
  title: string
  video: boolean
  voteAverage: number
  voteCount: number
}

export interface MovieEntry {
  id: string
  term: string
  title: string
  genre: string
  artworkUrl: string
  pixelatedArtworkUrl?: string
  selectedGenre?: string
  originalGenre?: string
}

export interface SearchMoviesResponse {
  page: number
  results: Movie[]
}

export const topMovieGenres = [
  { id: 28, name: 'Action' },
  { id: 12, name: 'Adventure' },
  { id: 16, name: 'Animation' },
  { id: 35, name: 'Comedy' },
  { id: 80, name: 'Crime' },
  { id: 105, name: 'Disaster Film' },
  { id: 99, name: 'Documentary' },
  { id: 18, name: 'Drama' },
  { id: 82, name: 'Eastern' },
  { id: 2916, name: 'Erotic Film' },
  { id: 14695, name: 'Exploitation Film' },
  { id: 14, name: 'Fantasy' },
  { id: 18847, name: 'Found Footage' },
  { id: 36, name: 'Historical Film' },
  { id: 27, name: 'Horror' },
  { id: 10402, name: 'Musicals' },
  { id: 1115, name: 'Road Movie' },
  { id: 878, name: 'Science Fiction' },
  { id: 10107, name: 'Sport Film' },
  { id: 53, name: 'Thriller' },
  { id: 37, name: 'Western' },
]

export const movieGenres = [
  { id: 28, name: 'Action' },
  { id: 12, name: 'Adventure' },
  { id: 16, name: 'Animation' },
  { id: 35, name: 'Comedy' },
  { id: 80, name: 'Crime' },
  { id: 99, name: 'Documentary' },
  { id: 18, name: 'Drama' },
  { id: 10751, name: 'Family' },
  { id: 14, name: 'Fantasy' },
  { id: 36, name: 'Historical Film' },
  { id: 27, name: 'Horror' },
  { id: 10402, name: 'Music' },
  { id: 9648, name: 'Mystery' },
  { id: 10749, name: 'Romance' },
  { id: 878, name: 'Science Fiction' },
  { id: 10770, name: 'TV Movie' },
  { id: 53, name: 'Thriller' },
  { id: 10752, name: 'War' },
  { id: 37, name: 'Western' },
  { id: 2891, name: 'Action Super Hero' },
  { id: 10106, name: 'Bad Cop' },
  { id: 2730, name: 'Buddy Cop' },
  { id: 14926, name: 'Girls with Guns' },
  { id: 16914, name: 'Heroic Bloodshed' },
  { id: 138, name: 'Military Film' },
  { id: 136, name: 'Secret Service' },
  { id: 147, name: 'Cloak-And-Dagger Film' },
  { id: 2741, name: 'Knight\'s Tale' },
  { id: 145, name: 'Pirate Film' },
  { id: 19454, name: 'Robinsonade' },
  { id: 89, name: 'Treasure Hunting' },
  { id: 34, name: 'Anime' },
  { id: 15520, name: 'Cartoon Anime' },
  { id: 196, name: 'Classical Animation' },
  { id: 15, name: 'Computer Animation' },
  { id: 197, name: 'Stop Motion' },
  { id: 18385, name: 'Action Comedy' },
  { id: 56, name: 'Black Comedy' },
  { id: 2713, name: 'Comedy Of Mistaken Identity' },
  { id: 9181, name: 'Alter Ego' },
  { id: 17126, name: 'Crime Comedy' },
  { id: 1125, name: 'Criminal Comedy Film' },
  { id: 18606, name: 'Dramedy' },
  { id: 1479, name: 'Erotic Comedy Film' },
  { id: 10105, name: 'Family Comedy' },
  { id: 2888, name: 'Farce' },
  { id: 2915, name: 'Gross-Out Film' },
  { id: 14415, name: 'Grotesque' },
  { id: 16304, name: 'Horror comedy' },
  { id: 14999, name: 'Parody' },
  { id: 126, name: 'Romantic Comedy' },
  { id: 114, name: 'Satire' },
  { id: 117, name: 'Political Satire' },
  { id: 1124, name: 'Anarchic Comedy Film' },
  { id: 115, name: 'Satire On Media' },
  { id: 116, name: 'Satire On War' },
  { id: 121, name: 'Screwball Comedy Film' },
  { id: 13544, name: 'Sitcom' },
  { id: 124, name: 'Slapstick Comedy Film' },
  { id: 1126, name: 'Teen Comedy Film' },
  { id: 2712, name: 'High School Comedy Film' },
  { id: 122, name: 'Tragicomedy' },
  { id: 144, name: 'Detective Film' },
  { id: 644, name: 'Film Noir' },
  { id: 2738, name: 'Gangster Film' },
  { id: 241, name: 'Heist Film' },
  { id: 250, name: 'Caper Movie' },
  { id: 249, name: 'Mafia Film' },
  { id: 252, name: 'Yakuza Film' },
  { id: 251, name: 'Police Film' },
  { id: 2737, name: 'Italian Crime Film' },
  { id: 105, name: 'Disaster Film' },
  { id: 2729, name: 'Accident' },
  { id: 103, name: 'Natural Disaster' },
  { id: 3172, name: 'Terrorism' },
  { id: 19644, name: 'Conspiracy theory film' },
  { id: 3119, name: 'Cultural Film' },
  { id: 3120, name: 'Educational Film' },
  { id: 3118, name: 'Essay Film' },
  { id: 206, name: 'Event Documentary' },
  { id: 201, name: 'Investigative Documentary' },
  { id: 205, name: 'Long Term Documentary' },
  { id: 3117, name: 'Making-Of Documentary' },
  { id: 208, name: 'Nature Documentary' },
  { id: 18323, name: 'Parascientific Documentary' },
  { id: 202, name: 'Political Documentary' },
  { id: 200, name: 'Scientific Documentary' },
  { id: 204, name: 'Social Study' },
  { id: 101, name: 'Staged Documentary' },
  { id: 19648, name: 'Dokufiction' },
  { id: 3114, name: 'Drama Documentary' },
  { id: 170, name: 'Haunted House Film' },
  { id: 158, name: 'Monster Film' },
  { id: 86, name: 'Animalhorror' },
  { id: 162, name: 'Cannibal-Movie' },
  { id: 159, name: 'Extraterrestrial Monsters' },
  { id: 3082, name: 'Ghost-Movie' },
  { id: 2932, name: 'Japanese Monster Movie' },
  { id: 15038, name: 'J-Horror' },
  { id: 163, name: 'Vampiremovie' },
  { id: 161, name: 'Werewolve-Movie' },
  { id: 164, name: 'Zombiefilm' },
  { id: 168, name: 'Occult Horror Film' },
  { id: 3083, name: 'Exorcism Film' },
  { id: 166, name: 'Obsession' },
  { id: 165, name: 'Satanism' },
  { id: 39, name: 'Slasher Film' },
  { id: 169, name: 'Teen Horror Film' },
  { id: 14710, name: 'Torture Porn' },
  { id: 157, name: 'Splatter Film / Gore Film' },
  { id: 3115, name: 'Mockumentary' },
  { id: 17724, name: 'Mondo' },
  { id: 3113, name: 'Reality Show' },
  { id: 15678, name: 'Travel documentary' },
  { id: 2890, name: 'Biopic' },
  { id: 2395, name: 'Blaxploitation' },
  { id: 2731, name: 'Buddy Film' },
  { id: 69, name: 'Coming Of Age' },
  { id: 54, name: 'Destiny' },
  { id: 71, name: 'Family Drama' },
  { id: 133, name: 'Family Saga' },
  { id: 127, name: 'Marital Tragedy' },
  { id: 134, name: 'Justice Drama' },
  { id: 135, name: 'Courtroom Drama' },
  { id: 92, name: 'Political Drama' },
  { id: 2889, name: 'Refugee Drama' },
  { id: 219, name: 'Psychodrama' },
  { id: 2370, name: 'Regional film' },
  { id: 2717, name: 'Mountain Film' },
  { id: 19, name: 'Romantic Drama' },
  { id: 130, name: 'Melodrama' },
  { id: 33, name: 'Romance Film' },
  { id: 44, name: 'Social Drama' },
  { id: 129, name: 'Coming Out' },
  { id: 82, name: 'Eastern' },
  { id: 81, name: 'Martial Arts' },
  { id: 3087, name: 'Ninja Film' },
  { id: 193, name: 'Samurai Film' },
  { id: 2926, name: 'Wuxia Film' },
  { id: 2916, name: 'Erotic Film' },
  { id: 3107, name: 'Lederhosen Film' },
  { id: 3108, name: 'Nudie Film' },
  { id: 3111, name: 'Sex Education' },
  { id: 3112, name: 'Sex Report Film' },
  { id: 3110, name: 'Sex Film' },
  { id: 3109, name: 'Sexploitation Film' },
  { id: 14695, name: 'Exploitation Film' },
  { id: 2761, name: 'Bangsian Fantasy' },
  { id: 154, name: 'Contemporary Fantasy' },
  { id: 13, name: 'Fairy Tale Film' },
  { id: 151, name: 'High Fantasy' },
  { id: 2757, name: 'Low Fantasy' },
  { id: 2774, name: 'Historical Fantasy' },
  { id: 152, name: 'Sword And Sorcery' },
  { id: 18847, name: 'Found Footage' },
  { id: 36, name: 'Historical Film' },
  { id: 32, name: 'Anti-War Film' },
  { id: 149, name: 'Monumental Film' },
  { id: 3084, name: 'Bible Film' },
  { id: 148, name: 'Swords and Sandals' },
  { id: 31, name: 'War Film' },
  { id: 22, name: 'Musicals' },
  { id: 14453, name: 'Concert film' },
  { id: 72, name: 'Dance Film' },
  { id: 14452, name: 'Musical' },
  { id: 1115, name: 'Road Movie' },
  { id: 2748, name: 'End Times Road Movie' },
  { id: 2744, name: 'Motorcycle Film' },
  { id: 3081, name: 'Racing Film' },
  { id: 2746, name: 'Truck Film' },
  { id: 52, name: 'Apocalypse & Post-Apocalypse' },
  { id: 218, name: 'Cyberpunk' },
  { id: 2979, name: 'Hard SF' },
  { id: 57, name: 'Retro SF' },
  { id: 11, name: 'Space Opera' },
  { id: 51, name: 'Time Travel' },
  { id: 43, name: 'Utopia & Dystopia' },
  { id: 10107, name: 'Sport Film' },
  { id: 76, name: 'Conspiracy Thriller' },
  { id: 142, name: 'Erotic Thriller' },
  { id: 79, name: 'Mystery Thriller' },
  { id: 106, name: 'Political Thriller' },
  { id: 141, name: 'Psychological Thriller' },
  { id: 190, name: 'Classical Western' },
  { id: 40, name: 'Late Western' },
  { id: 192, name: 'Ostern' },
  { id: 191, name: 'Spaghetti Western' },
]
